import { render, staticRenderFns } from "./globalUploader.vue?vue&type=template&id=0e866bfe&scoped=true"
import script from "./globalUploader.vue?vue&type=script&lang=js"
export * from "./globalUploader.vue?vue&type=script&lang=js"
import style0 from "./globalUploader.vue?vue&type=style&index=0&id=0e866bfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e866bfe",
  null
  
)

export default component.exports